'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/object.values/polyfill.js
// module id = 735
// module chunks = 168707334958949